

















































// import { ConfirmModal, FormBlock, FormCard } from '@/app/components';
import { Ref, computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import { RetrievalType } from '../../../constants';

export default defineComponent({
    name: 'RetrievalSettings',
    model: {
        prop: 'retrievalType',
        event: 'change',
    },
    props: {
        title: {
            type: String,
            default: 'Retrieval Settings',
        },
        retrievalType: {
            type: String,
            default: null,
        },
        schedulesExist: {
            type: Boolean,
            default: false,
        },
        isRunning: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        allowPeriodic: {
            type: Boolean,
            default: true,
        },
    },
    // components: { FormBlock, FormCard, ConfirmModal },
    setup(props, { emit }) {
        const defaultRetrievalTypes = {
            [RetrievalType.Immediately]: 'Retrieve Immediately',
            [RetrievalType.Once]: 'Retrieve Once',
            // [RetrievalType.Polling]: 'Polling (every 60 seconds)',
        };

        const retrievalTypes = computed(() =>
            props.allowPeriodic
                ? {
                      ...defaultRetrievalTypes,
                      [RetrievalType.Periodic]: 'Periodic Retrieval (according to schedule)',
                  }
                : defaultRetrievalTypes,
        );

        const newRetrievalType = ref<RetrievalType | undefined>();

        const selectedRetrievalType: Ref<string> = computed({
            get: () => props.retrievalType,
            set: (retrievalTypeToBeSet: string) => {
                emit('change', retrievalTypeToBeSet);
            },
        });

        const checkRetrievalTypeChange = (event: any) => {
            if (event.target.value !== selectedRetrievalType.value && props.schedulesExist)
                newRetrievalType.value = event.target.value;
            else confirmRetrievalTypeChange(event.target.value);
        };

        const confirmRetrievalTypeChange = (retrievalType: RetrievalType) => {
            selectedRetrievalType.value = retrievalType;
            newRetrievalType.value = undefined;
        };

        // Periodic retrieval is the default; the retrieval type options are no longer exposed in the UI.
        // An already configured retrieval type is left untouched, so that its schedules are not lost.
        onMounted(() => {
            const defaultRetrievalType = props.allowPeriodic ? RetrievalType.Periodic : RetrievalType.Immediately;
            if (props.retrievalType === defaultRetrievalType) return;
            if (props.retrievalType && (props.schedulesExist || props.isRunning || props.disabled)) return;
            selectedRetrievalType.value = defaultRetrievalType;
        });

        return {
            newRetrievalType,
            retrievalTypes,
            selectedRetrievalType,
            checkRetrievalTypeChange,
            confirmRetrievalTypeChange,
        };
    },
});
